import { call } from './client'
import type { Listing, ScheduleInput } from '../types'

export const listings = (state?: string): Promise<Listing[]> =>
  call(`/listings${state ? `?state=${state}` : ''}`)

export const schedule = (body: ScheduleInput): Promise<Listing> =>
  call('/listings', { method: 'POST', body })

export const cancel = (id: number): Promise<Listing> =>
  call(`/listings/${id}/cancel`, { method: 'POST' })

export const runNow = (id: number): Promise<Listing> =>
  call(`/listings/${id}/run`, { method: 'POST' })
